import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../../utils/Api"; 
import CreateCategory from "./popups/createCategory"; 
import ViewCategory from "./popups/viewCategory";
import Loader from "../../common/loader";
import {deleteCategory} from "../../../Services/CategoryServices"
import { toast } from 'react-toastify';
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");
const Categories = ({ data }) => {
  const tableRef = useRef(null); 
  const [render, setRender] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [createCategoryModal, setCreateCategoryModal] = useState(false);
  const [viewCategoryModal, setViewCategoryModal] = useState(false);
  const [popupType, setPopupType] = useState('CREATE');
  const [rowDataId, serRowDataId] = useState({});
  const navigate = useNavigate();
  const createCategoryModalClose=()=>{
   setCreateCategoryModal(false)
  } 
  const viewCategoryModalClose=()=>{
   setViewCategoryModal(false)
  }
  useEffect(() => {
  if(!checkPermissions('category_page') || !checkPermissions('games_navigation')){ 
      navigate('/')
    }
  },[])
  useEffect(() => {
    // Initialize DataTable
    const table = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      serverMethod: "get",
      ajax: {
        url: `${getEnvUrl()}/admin/category/categoryReport`,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getToken()}`,
        },
      },
      columns: [
        { data: "id" },
        { data: "name" },
        { data: "subject" },
        { data: "levelorder" },
        { data: "active" },
        { 
         data: null,
         title: 'Actions',
         render:  (data, type, row) => (
           `<div> 
           <span class="a-edit"><i class="bi bi-pencil-square"></i></span>
           <span class="a-view"><i class="bi bi-eye-fill"></i></span>
           <span class="a-delete"><i class="bi bi-trash-fill"></i></span>
           </div>`
         )
           }
      ],
      createdRow: (row, data, dataIndex) => {  
        if(!checkPermissions('category_edit')){
          $(row).find('.a-edit').remove();
        }
        if(!checkPermissions('category_view')){
          $(row).find('.a-view').remove();
        }
        if(!checkPermissions('category_delete')){
          $(row).find('.a-delete').remove();
        }

         $(row).find('.a-edit').on('click', () => { 
          serRowDataId(data.id)
          setCreateCategoryModal(true)
          setPopupType('EDIT')
         });   
         $(row).find('.a-view').on('click', () => { serRowDataId(data.id); setViewCategoryModal(true)} );        
         $(row).find('.a-delete').on('click', () => {  
          if(window.confirm('Are you sure to delete?')){
            deleteCategory(data.id).then((data)=>{ 
              if(data.status){
                   toast.success(data.message)
                   rerender()
              } else{
                toast.error(data.errorMessage) 
              }
            })  
          } 

         } );
       },
      drawCallback: function(settings) {
        setIsLoading(false);
      },
      'columnDefs': [ {
        'targets': [5], /* column index */
        'orderable': false, /* true or false */
     }], 
      aaSorting: [[0, "desc"]],
    });

    return () => {
      // Destroy DataTable when component unmounts to avoid memory leaks
      table.destroy();
    };
  }, [data,render]);

  const rerender=()=>{
    setRender(!render)
  }
  return (
    <div>
    <main id="main" className="main">
       <div className="pagetitle">
          <h1>Categories</h1>
       </div>
       <section className="section">
          <div className="row">
             <div className="col-lg-12">
                <div className="card p-10">
                      <h5 className="card-title">
                        {checkPermissions('category_create') && 
                         <button type="button"
                           onClick={()=>{setCreateCategoryModal(true);setPopupType('CREATE');}}
                          className="btn btn-primary float-right"
                          id="addcat" >
                         + Add categories
                         </button>}
                      </h5>
                      {isLoading?
                     <Loader />
                      :"" }
                      <div className={isLoading?'card-body hide':'card-body'}>          
                      <table
                         className="table table-striped table-hover table-bordered no-footer dataTable"
                         width="100%"
                         ref={tableRef}
                         >
                         <thead>
                            <tr>
                               <th>Category Id</th>
                               <th>Name</th>
                               <th>Subject</th>
                               <th>Order</th>
                               <th>Active</th>
                               <th>Action</th>
                            </tr>
                         </thead>
                      </table>
                   </div>
                </div>
          </div>
 </div>
 </section>
 </main>  
 {createCategoryModal?<CreateCategory 
 popupType={popupType}
 editDataid={rowDataId}
 reRender={rerender}
 isShow={createCategoryModal} 
 close={createCategoryModalClose}  />:''} 
  {viewCategoryModal?<ViewCategory 
   viewDataid={rowDataId}
  isShow={viewCategoryModal} close={viewCategoryModalClose}  />:''} 
 
 </div>
  );
};

export default Categories;